import { Component, OnInit } from '@angular/core';
import { CloudFunctionsService } from '../../services/cloud-functions.service';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { StoreHistoryEntry } from 'src/app/models/store-history-entry';
import { StoreHistoryService } from 'src/app/services/store-history-service.service';
import { InitializationService } from 'src/app/services/initialization.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})

export class HomeComponent implements OnInit 
{
  history:Array<StoreHistoryEntry> = new Array<StoreHistoryEntry>();
  title='';
  button='';
  contactus='';

  constructor(
    private router: Router,
    private storehistoryservice: StoreHistoryService,
    private initializationservice: InitializationService
    ) {  }

  ngOnInit(): void 
  {
    this.setMessage();

    this.history = this.storehistoryservice.getPlaceHistory();
  }

  contactUs(): void
  {
    this.router.navigateByUrl("/contactus");
  }

  goToStore(entry:StoreHistoryEntry)
  {
    this.initializationservice.setReload();
    this.router.navigateByUrl('/' + entry.Path);
  }

  setMessage()
  {
    var locale = this.getUsersLocale("pt");

    switch(locale)
    {
      case "pt":
        this.title = "Recente";
        this.button = "Ver";
        this.contactus = "Fale com Snacktime"
        break;
      case "en":
        this.title = "Recent";
        this.button = "Go";
        this.contactus = "Contact Snacktime"
        break;
      default:
        this.title = "Recent";
        this.button = "Go";
        this.contactus = "Contact Snacktime"
        break;
    }
  }

  getUsersLocale(defaultValue: string): string 
  {
    if (typeof window === 'undefined' || typeof window.navigator === 'undefined')
      return defaultValue;

    const wn = window.navigator as any;

    let lang = wn.languages ? wn.languages[0] : defaultValue;

    lang = lang || wn.language || wn.browserLanguage || wn.userLanguage;

    let langString = String(lang);

    let dashIndx = langString.indexOf('-');

    if(dashIndx > -1)
    langString = langString.split('-', 2)[0];

    return langString;
  }
}